import { useIsMobile } from "../../hooks/useIsMobile";

interface Props {
  total: number;
  thisMonth: number;
  count: number;
}

export function SummaryBar({ total, thisMonth, count }: Props) {
  const isMobile = useIsMobile();
  return (
    <div style={{ background: "#0f172a", padding: isMobile ? "0.75rem 1rem" : "0.75rem 1.5rem", display: "flex", gap: isMobile ? "1rem" : "2rem", flexWrap: "wrap", borderBottom: "1px solid #1e293b" }}>
      <Stat label="This month" value={`£${thisMonth.toFixed(2)}`} />
      <Stat label="Total (filtered)" value={`£${total.toFixed(2)}`} />
      <Stat label="Receipts" value={String(count)} />
    </div>
  );
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div style={{ color: "#64748b", fontSize: "0.75rem" }}>{label}</div>
      <div style={{ color: "#4ade80", fontWeight: 700, fontSize: "1.1rem" }}>{value}</div>
    </div>
  );
}
